import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './InsurancePlanFeaturesModal.css';
import cs from '../../components/commonStyle.css';
import { IoCheckmarkCircle } from "react-icons/io5";
import { Modal } from 'react-bootstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import messages from '../../locale/messages';

class InsurancePlanFeaturesModal extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
    };

    render() {
        const { onClose, show } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <Modal show={show} animation={false} onHide={onClose} className="insuranceModal">
                <div className={cx(s.sectionBlock)}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className={cx(s.insuranceContent)}>
                            <h2 className={cx(s.titleText)}>What’s includes in your Daily plan?</h2>
                            <ul className={cx(s.featureList)}>
                                <li>
                                    <IoCheckmarkCircle />
                                    <p>Single Trip</p>
                                </li>
                                <li>
                                    <IoCheckmarkCircle />
                                    <p>Covers excess liability for theft & damage</p>
                                </li>
                                <li>
                                    <IoCheckmarkCircle />
                                    <p>Windscreen, Tires, Wheels and Light</p>
                                </li>
                                <li>
                                    <IoCheckmarkCircle />
                                    <p>Undercarriage</p>
                                </li>
                                <li>
                                    <IoCheckmarkCircle />
                                    <p>Single Vehicle Accidents</p>
                                </li>
                                <li>
                                    <IoCheckmarkCircle />
                                    <p>Luggage & Personal Effects ($500 per claim)</p>
                                </li>
                            </ul>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        );
    }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(InsurancePlanFeaturesModal)));